/************************************************************
 Blood Namespace
 ************************************************************/

 window.bloodNS = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;
        debug.log('action',action);
        // Cancel Requisition
        if (actionId == 3) {
            bloodNS.openReason(bloodNS.cancelRequisitionModalHandler);
        }
        //Undo Received
        else if ( actionId == 57){
            debug.log('Undo Received');
            bloodNS.validateBloodConsuming();
            //bloodNS.openReason(bloodNS.cancelReceivedModalHandler);
        }
        // Received
        else if (actionId == 18) {
            bloodNS.openMovements(bloodNS.onBloodMovementsHandler);
        }
        // Returned
        else if (actionId == 58) {
            bloodNS.validateFullBloodConsuming();
            //bloodNS.openMovements(bloodNS.onBloodMovementsHandler);
        }
        // Transfer
        else if (actionId == 52) {
            bloodNS.validateFullBloodConsuming();
            //bloodNS.openMovements(bloodNS.onBloodMovementsHandler);
        }
        // Other actions
        else {
            debug.log('Other actions');
            bloodNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        debug.log('executeGenericAction');
        // Show alert for actions without undo
        workflow.executeAction(bloodNS._action, bloodNS._callback, bloodNS._row);
    },

    validateBloodConsuming: function () {
       var params = {
           task_id: bloodNS._action.task_id
       };

        $.getJSON('/blood/validate_blood_consuming/', params)
            .done(function (data, status, xhr) {

               if (data.result == true) {
                   bootbox.alert(GlobalTranslations.appLabel2299);
               } else {
                   bloodNS.openReason(bloodNS.cancelReceivedModalHandler);
               }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    validateFullBloodConsuming: function () {
        var params = {
            task_id: bloodNS._action.task_id
        };
        var msg = "";
        if (bloodNS._action.wf_action_id == globalConstants.ACTION_BLOOD_RETURNED) {
            msg = GlobalTranslations.appLabel2300;
        } else if (bloodNS._action.wf_action_id == globalConstants.ACTION_BLOOD_TRANSFER ) {
            msg = GlobalTranslations.appLabel2301;
        }
        $.getJSON('/blood/validate_full_blood_consuming/', params)
            .done(function (data, status, xhr) {
                debug.log('validateFullBloodConsuming', data.result);
                if (data.result == false) {
                    bootbox.alert(msg);
                } else {
                    bloodNS.openMovements(bloodNS.onBloodMovementsHandler);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    // Open Reason
    openReason:function (callback) {
        debug.log('openReason');
        var params = {
            task_id:bloodNS._action.task_id,
            wf_id:bloodNS._action.wf_id,
            wf_status_id:bloodNS._action.to_state_id,
            wf_action_id:bloodNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                bloodNS._callback(false, bloodNS._action, bloodNS._row);
            });
    },
    // Cancel Requisition
    cancelRequisitionModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:bloodNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:bloodNS._row.wf_id,
            wf_status_id:bloodNS._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/blood/cancel_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    bloodNS._callback(false, bloodNS._action, bloodNS._row);
                } else {
                    bloodNS._callback(true, bloodNS._action, bloodNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                bloodNS._callback(false, bloodNS._action, bloodNS._row);
            });
    },
    //Undo Received
    cancelReceivedModalHandler: function (event, data){
        debug.log('cancelReceivedModalHandler');
        $.fancybox.close(true);

        var params = {
            task_id:bloodNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:bloodNS._row.wf_id,
            wf_status_id:bloodNS._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/blood/undo_received', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    bloodNS._callback(false, bloodNS._action, bloodNS._row);
                } else {
                    bloodNS._callback(true, bloodNS._action, bloodNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                bloodNS._callback(false, bloodNS._action, bloodNS._row);
            });
    },
    //Open Modal received or returned
    openMovements: function (callback) {
        Hades.showLoading();

        var params = {
            task_id:bloodNS._action.task_id,
            wf_id:bloodNS._action.wf_id,
            wf_status_id:bloodNS._action.to_state_id,
            wf_action_id:bloodNS._action.wf_action_id};

        $.get('/blood/blood_movements_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#blood-movements-modal-ct').bind('receivedReturnedConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                bloodNS._callback(false, bloodNS._action, bloodNS._row);
            });
    },

    onBloodMovementsHandler: function (success, data) {
        $.fancybox.close(true);
        bloodNS._callback(success, bloodNS._action, bloodNS._row);
    }
};
